import * as React from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Typography from '@mui/joy/Typography';


const PaymentMethod = () => {
    return (

        <Card
          sx={{ width: '356px', maxWidth: '100%', height: '261px', mt:2,pt:3}}
        >
            <Typography level="h3">
                Payment Method
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 ,mt:2}}>
                
                <CheckCircleIcon sx={{color:'#28A745'}}/>
               
                <Typography level="body-md">
                    Setup PayPal Account
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1,mt:2 }}>
            <CheckCircleIcon sx={{color:'#28A745'}}/>
                <Typography level="body-md">
                Setup Bank Account
                </Typography>
            </Box>
            
            <CardActions sx={{mt:2}}>
                <Button variant="solid">Confirm</Button>
            </CardActions>
        </Card>

    )
}

export default PaymentMethod;